import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/BusTrip.png'


const _hoisted_1 = { id: "route" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal" }, "Rute", -1)
const _hoisted_5 = { class: "flex mt-4" }
const _hoisted_6 = { class: "flex items-center mr-3" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h6", {
  class: "font-normal",
  style: {"color":"#EF5350"}
}, "Harga Retail:  ", -1)
const _hoisted_8 = { class: "font-normal cursor-pointer color-blue-grey" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "pi pi-sort-down text-base cursor-pointer color-blue-grey" }, null, -1)
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = /*#__PURE__*/_createVNode("h6", { class: "font-normal color-green-darken-1" }, "Harga Company:  ", -1)
const _hoisted_12 = { class: "font-normal cursor-pointer color-blue-grey" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "pi pi-sort-down text-base cursor-pointer color-blue-grey" }, null, -1)
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = {
  class: "flex border-right-grey-lighten-3 flex-1 px-3",
  style: {"width":"40%"}
}
const _hoisted_16 = {
  class: "",
  style: {"width":"30%"}
}
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-center" }, "Kota Asal", -1)
const _hoisted_18 = { class: "font-bold text-center -mb-2" }
const _hoisted_19 = { class: "font-semibold text-center break-all" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", {
  class: "flex justify-center items-center",
  style: {"width":"40%"}
}, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_21 = { style: {"width":"30%"} }
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-center font-normal" }, "Kota Tujuan", -1)
const _hoisted_23 = { class: "font-bold text-center -mb-2" }
const _hoisted_24 = { class: "font-semibold text-center break-all" }
const _hoisted_25 = {
  class: "flex items-center border-right-grey-lighten-3 px-3",
  style: {"width":"25%"}
}
const _hoisted_26 = { class: "px-5" }
const _hoisted_27 = /*#__PURE__*/_createVNode("p", { class: "text-sm" }, "Harga Retail", -1)
const _hoisted_28 = { class: "flex w-full" }
const _hoisted_29 = { class: "font-semibold text-3xl break-all" }
const _hoisted_30 = {
  class: "flex items-center border-right-grey-lighten-3 px-3",
  style: {"width":"25%"}
}
const _hoisted_31 = { class: "px-5" }
const _hoisted_32 = /*#__PURE__*/_createVNode("p", { class: "text-sm" }, "Harga Company", -1)
const _hoisted_33 = { class: "flex w-full" }
const _hoisted_34 = { class: "font-semibold text-3xl break-all" }
const _hoisted_35 = {
  class: "px-6 flex items-center justify-center",
  style: {"width":"10%"}
}
const _hoisted_36 = {
  key: 0,
  class: "overflow-y-auto ",
  style: {"max-height":"8rem"}
}
const _hoisted_37 = {
  key: 1,
  class: "overflow-y-auto ",
  style: {"max-height":"8rem"}
}
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "my-no-more" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_Card = _resolveComponent("Card")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_VueEternalLoading = _resolveComponent("VueEternalLoading")
  const _component_RouteForm = _resolveComponent("RouteForm")
  const _component_Sidebar = _resolveComponent("Sidebar")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            (_ctx.route.meta.permission.write)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Tambah Rute",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectAdd())),
                  icon: "pi pi-plus",
                  class: "font-semibold p-button-sm btn-primary"
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", null, [
            _createVNode(_component_InputIconRightGrey, {
              modelValue: _ctx.inputSearch,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputSearch = $event)),
              placeholder: "Cari Disini ...",
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.searchData(_ctx.inputSearch)), ["enter"])),
              type: _ctx.$enumBase.input.text,
              icon: _ctx.$icon.svg.searchEva
            }, null, 8, ["modelValue", "type", "icon"])
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("div", {
              class: "flex items-center",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDropDownFilter($event, 'filterRetail')))
            }, [
              _createVNode("h6", _hoisted_8, _toDisplayString(_ctx.hargaRetail.label), 1),
              _hoisted_9
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode("div", {
              class: "flex items-center",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDropDownFilter($event, 'filterCompany')))
            }, [
              _createVNode("h6", _hoisted_12, _toDisplayString(_ctx.hargaCompany.label), 1),
              _hoisted_13
            ])
          ])
        ])
      ]),
      content: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataRoute, (item, index) => {
          return (_openBlock(), _createBlock(_component_Card, {
            class: "card-no-shadow card-item-category mb-4",
            key: index
          }, {
            content: _withCtx(() => [
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode("h4", _hoisted_18, _toDisplayString(item.OrigCityCode), 1),
                    _createVNode("h6", _hoisted_19, _toDisplayString(item.OrigCityName), 1)
                  ]),
                  _hoisted_20,
                  _createVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode("h4", _hoisted_23, _toDisplayString(item.DestCityCode), 1),
                    _createVNode("h6", _hoisted_24, _toDisplayString(item.DestCityName), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_25, [
                  _createVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createVNode("div", _hoisted_28, [
                      _createVNode("p", _hoisted_29, _toDisplayString(item.RetailPriceCode), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_30, [
                  _createVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode("div", _hoisted_33, [
                      _createVNode("p", _hoisted_34, _toDisplayString((item.CompanyPriceCode)), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_35, [
                  (_ctx.route.meta.permission.update)
                    ? (_openBlock(), _createBlock("i", {
                        key: 0,
                        class: "pi pi-ellipsis-h text-base cursor-pointer text-black",
                        onClick: ($event: any) => (_ctx.showDropDown($event, item))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Paginator, {
          rows: _ctx.filters.pageSize,
          totalRecords: _ctx.filters.totalRecords,
          onPage: _ctx.onPage
        }, null, 8, ["rows", "totalRecords", "onPage"])
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, { ref: "op" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          del: false,
          edit: _ctx.route.meta.permission.update,
          onDel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteData(_ctx.dataForm.Id))),
          onEdit: _cache[7] || (_cache[7] = ($event: any) => (_ctx.editData(_ctx.dataForm)))
        }, null, 8, ["edit"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_OverlayPanel, {
      ref: "asTooltip",
      class: "p-2 font-semibold text-3xl"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.currentTolltip), 1)
      ]),
      _: 1
    }, 512),
    _createVNode(_component_OverlayPanel, {
      ref: "filterOp",
      class: "p-5"
    }, {
      default: _withCtx(() => [
        (_ctx.actionPage === 'filterRetail')
          ? (_openBlock(), _createBlock("div", _hoisted_36, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hargaOption, (data) => {
                return (_openBlock(), _createBlock("ul", {
                  class: ["mb-2 listFilter", data.value === _ctx.hargaRetail.value ? 'color-primary' : ''],
                  key: data.value,
                  onClick: ($event: any) => (_ctx.filterHargaRetail(data))
                }, [
                  _createVNode("li", null, _toDisplayString(data.label), 1)
                ], 10, ["onClick"]))
              }), 128))
            ]))
          : (_ctx.actionPage === 'filterCompany')
            ? (_openBlock(), _createBlock("div", _hoisted_37, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hargaOption, (data) => {
                  return (_openBlock(), _createBlock("ul", {
                    class: ["mb-2 listFilter", data.value === _ctx.hargaCompany.value ? 'color-primary' : ''],
                    key: data.value,
                    onClick: ($event: any) => (_ctx.filterHargaRetail(data))
                  }, [
                    _createVNode("li", null, _toDisplayString(data.label), 1)
                  ], 10, ["onClick"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
        _createVNode(_component_VueEternalLoading, {
          load: _ctx.loadData,
          "is-initial": _ctx.isInitial,
          "onUpdate:is-initial": _cache[8] || (_cache[8] = ($event: any) => (_ctx.isInitial = $event)),
          class: "flex justify-center"
        }, {
          loading: _withCtx(() => [
            _createVNode(_component_ProgressSpinner, {
              class: "h-14",
              strokeWidth: "5"
            })
          ]),
          "no-more": _withCtx(() => [
            _hoisted_38
          ]),
          _: 1
        }, 8, ["load", "is-initial"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Sidebar, {
      class: "type-bus-sidebar",
      visible: _ctx.sliderActive,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (_ctx.sliderActive = $event)),
      showCloseIcon: false,
      position: "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_RouteForm, {
          data: _ctx.dataForm,
          onCloseSidebar: _ctx.closeSidebar,
          onReloadData: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getRoute()))
        }, null, 8, ["data", "onCloseSidebar"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}